import { Action } from 'redux';

import { Resort } from '../entities';

export enum TResort {
  SET_RESORTS = 'SET_RESORTS',
  SET_RESORT = 'SET_RESORT',
  FETCH_RESORTS = 'FETCH_RESORTS',
}

export interface ISetResorts extends Action {
  type: TResort.SET_RESORTS;
  payload: Resort[];
}
export const ASetResorts = (payload: Resort[]): ISetResorts => ({ type: TResort.SET_RESORTS, payload });

export interface ISetResort extends Action {
  type: TResort.SET_RESORT;
  payload: Resort;
}
export const ASetResort = (payload: Resort): ISetResort => ({ type: TResort.SET_RESORT, payload });

export interface IFetchResorts extends Action {
  type: TResort.FETCH_RESORTS;
}
export const AFetchResorts = (): IFetchResorts => ({ type: TResort.FETCH_RESORTS });
